'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var PropTypes = _interopDefault(require('prop-types'));

var propTypes = {
  Tracker: PropTypes.shape({
    dispatch: PropTypes.func.isRequired
  })
};

exports.default = propTypes;
